import { Dispatch } from 'react';
import { connect } from 'react-redux';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { AddressesActions } from '../addressesActions';
import { AddressesAction } from '../addressesActionType';
import { IAddress } from './address.interface';
import JPAddress from './JPAddress';

const mapStateToProps = (state: IReduxRootState) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<AddressesAction>) => {
    return {
        deleteAddress: (addressUuid: string) => {
            dispatch(AddressesActions.deleteAddress(addressUuid));
        },
        setDefaultShipping: (address: IAddress, isShipping: boolean) => {
            dispatch(AddressesActions.setDefaultShipping(address, isShipping));
        },
    };
};

const JPAddressContainer = connect(mapStateToProps, mapDispatchToProps)(JPAddress);

export default JPAddressContainer;
